import React, { useEffect } from "react";

import { setSVGColor } from "../SVGHelper";
import "../style/typography.scss";
import "../style/colors.scss";
import "../style/buttons.scss";
import "../style/inputs.scss";
import editIcon from "../icon/dashboard/Edit/Edit 1.svg";
import saveIcon from "../icon/dashboard/Save.svg";
import SimpleIconButton from "./SimpleIconButton";
import "../style/shadows.scss";

// for avoiding null checks + stable reference to avoid triggering updates
const identityFn = (x) => x;

const InlineEditableText = ({
    value,
    onSave,
    format = identityFn, //todo: be more careful with when we apply this? i think that we might be returning formatted text in onSave and getting infinite linebreak hints in our text in the preferred name field
    noLayoutSpaceForIcons = false,
    style,
    className,
}) => {
    const ICON_WIDTH = "24px";

    const [highlightEdit, setHighlightEdit] = React.useState(false);
    const [editFocused, setEditFocused] = React.useState(false);
    const [hasChanges, setHasChanges] = React.useState(false);
    const [changeSaved, setChangeSaved] = React.useState(false);
    const elementRef = React.useRef(null);
    useEffect(() => {
        console.debug("useEffect: value:", value, " formated value:", format(value), format);
        elementRef.current.textContent = format(value);
        setHasChanges(false);
    }, [value, format]);
    const [animateSaveReminder, _setAnimateSaveReminder] = React.useState(false);
    const animateSaveReminderTimer = React.useRef(null);
    const startSaveReminderAnimation = () => {
        animateSaveReminderTimer.current = setTimeout(() => {
            _setAnimateSaveReminder(true);
            if (animateSaveReminderTimer?.current) clearTimeout(animateSaveReminderTimer.current);
            animateSaveReminderTimer.current = setTimeout(() => {
                _setAnimateSaveReminder(false);
                animateSaveReminderTimer.current = null;
            }, 600);
        }, 200);
    };
    const save = () => {
        _setAnimateSaveReminder(false);
        clearTimeout(animateSaveReminderTimer.current);
        onSave(elementRef.current.textContent);
        setChangeSaved(true);
        setHasChanges(false);
        setHighlightEdit(false);
    };

    const augmentedStyle = {
        display: "flex",
        alignItems: "center",
        ...style,
    };

    return (
        <>
            {/* todo: move to scss once finalized */}
            <style>{`
        .covert-input:focus {
          background-color: var(--colors-base-00);
        }
        .covert-input__editing {
          padding: 0px 4px;
        }
        @keyframes shake {
          0% {
            transform: scale(1.15) rotate(5deg);
          }
          25% {
            transform: scale(1.3333) rotate(10deg);
          }
          50% {
            transform: scale(1.13) rotate(-9deg);
          }
          75% {
            transform: scale(1.08) rotate(6deg);
          }
        }

        .animate-shake {
          transform-origin: 12px center;
          animation: shake .45s linear;
        }
        
      `}</style>
            <span
                onMouseEnter={() => {
                    if (hasChanges) return;
                    setHighlightEdit(true);
                }}
                onMouseLeave={() => {
                    setHighlightEdit(false);
                }}
                onClick={() => {
                    if (hasChanges) return;
                    setHighlightEdit(false);
                    setTimeout(() => elementRef.current?.focus(), 0);
                }}
                style={augmentedStyle}
                className={className}
            >
                <p
                    spellCheck={false}
                    contentEditable
                    className={"covert-input" + (hasChanges ? " covert-input__editing" : "")}
                    style={{
                        wordBreak: "break-word",
                    }}
                    ref={elementRef}
                    onFocus={(e) => {
                        setEditFocused(true);
                    }}
                    onBlur={(e) => {
                        console.debug("onBlur", e.target.textContent);
                        setTimeout(() => setEditFocused(false), 200);
                        e.target.textContent = format(e.target.textContent?.trim() || value); // if no previous value, revert to original

                        if (elementRef.current.textContent === value) {
                            setHighlightEdit(false);
                            setHasChanges(false);
                        } else {
                            startSaveReminderAnimation();
                        }
                    }}
                    //start editing on input incase they tab to it without clicking it and start typing
                    onInput={(e) => {
                        setHasChanges(e.target.textContent.trim() !== value);
                    }}
                    //handle enter key
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            console.debug("enter key pressed");
                            e.target.blur();
                            if (hasChanges) save();
                        }
                    }}
                />
                {/* save button */}
                <SimpleIconButton
                    src={saveIcon}
                    onClick={() => {
                        console.debug("save button clicked");
                        save();
                    }}
                    className={animateSaveReminder ? "animate-shake" : ""}
                    style={{
                        display: hasChanges ? "inline-block" : "none",
                        width: noLayoutSpaceForIcons ? "0" : ICON_WIDTH,
                    }}
                    beforeInjection={(svg) => {
                        setSVGColor("currentColor")(svg);
                        svg.setAttribute("width", ICON_WIDTH);
                        svg.setAttribute("height", ICON_WIDTH);
                    }}
                />
                {/* edit button */}
                <SimpleIconButton
                    src={editIcon}
                    style={{
                        display: hasChanges || editFocused || (changeSaved && !highlightEdit) ? "none" : "inline-block",
                        opacity: highlightEdit ? "1" : ".333",
                        color: highlightEdit ? "var(--colors-primary-blue-400)" : "var(currentColor)",
                        width: noLayoutSpaceForIcons ? "0" : ICON_WIDTH,
                    }}
                    beforeInjection={(svg) => {
                        setSVGColor("currentColor")(svg);
                        svg.setAttribute("width", ICON_WIDTH);
                        svg.setAttribute("height", ICON_WIDTH);
                    }}
                />
            </span>
        </>
    );
};

export default InlineEditableText;
